import type {
  BrowserCacheLocation,
  IPublicClientApplication,
} from '@azure/msal-browser'

import { SIGN_OUT_PARAM } from '../../components/SignInPage'

const storageOptionsThatSupportRedirect: string[] = [
  'sessionStorage',
  'localStorage',
] satisfies BrowserCacheLocation[]

export const getAuthenticationActions = ({
  instance,
  redirectUri,
}: {
  instance: IPublicClientApplication
  redirectUri: string | undefined
}) => {
  const {
    loginPopup,
    loginRedirect,
    logoutPopup,
    logoutRedirect,
    getConfiguration,
    acquireTokenRedirect,
    acquireTokenPopup,
  } = instance

  const isSupportingRedirect = storageOptionsThatSupportRedirect.includes(
    getConfiguration.call(instance).cache.cacheLocation, // using `call(instance)` to ensure it's bound to the instance (has the correct 'this' context)
  )

  const postLogoutRedirectUri = `${redirectUri ?? window.location.origin}/?${SIGN_OUT_PARAM}`

  return {
    login: isSupportingRedirect
      ? loginRedirect.bind(instance)
      : loginPopup.bind(instance),
    logout: isSupportingRedirect
      ? logoutRedirect.bind(instance, { postLogoutRedirectUri })
      : logoutPopup.bind(instance, { postLogoutRedirectUri }),
    acquireTokenInteractively: isSupportingRedirect
      ? acquireTokenRedirect.bind(instance)
      : acquireTokenPopup.bind(instance),
  }
}
